type FieldKeys = {
  id: string;
  name: string;
  showInactive: string;
  search: string;
};

const fieldKeys: FieldKeys = {
  id: 'id',
  name: 'name',
  showInactive: 'includeInactive',
  search: 'search',
};

export default fieldKeys;
